var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27757 0.589794C6.10952 0.477637 5.89049 0.477637 5.72244 0.589794L0.727722 3.92332C0.316356 4.19787 0.510714 4.8392 1.00528 4.8392H3.19166V7C3.19166 7.27614 3.41552 7.5 3.69166 7.5H8.06241C8.33855 7.5 8.56241 7.27614 8.56241 7V4.8392H10.9947C11.4893 4.8392 11.6837 4.19787 11.2723 3.92332L6.27757 0.589794Z",
    fill: "#00C853"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.7b17756a6b023677a1d2d7ef783180dc.svg";
export { ForwardRef as ReactComponent };